import React from 'react';
import { FooterContainer, FooterLogo, FooterText } from './styled';
import { INFORMATION } from "../../const/company"
import logo from "../../images/logo-gray.png";

function Footer() {
    return (
        <FooterContainer>

            <FooterLogo>
                <img src={logo} alt="" />
            </FooterLogo>
            
            <FooterText>
                (주)디벨로시티 | 사업자번호: {INFORMATION.business_number} <br />
                {INFORMATION.address} <br />
                {INFORMATION.phone_number} | {INFORMATION.fax}
            </FooterText>

        </FooterContainer>
    );
}

export default Footer;